import { Injectable } from "@angular/core";

import { ElementContainerComponent } from "@lantern/app/common/utils/element-container.component";

@Injectable()
export class ElementContainerRegistry {
  private map: WeakMap<HTMLElement, ElementContainerComponent> = new WeakMap<
    HTMLElement,
    ElementContainerComponent
  >();

  get(elem: HTMLElement): ElementContainerComponent | undefined {
    return this.map.get.call(this.map, elem);
  }

  set(elem: HTMLElement, container: ElementContainerComponent): void {
    this.map.set(elem, container);
  }

  delete(elem: HTMLElement): void {
    this.map.delete(elem);
  }

  getContainers(elem: HTMLElement): ElementContainerComponent[] {
    let containers: ElementContainerComponent[] = [],
      container: ElementContainerComponent | undefined;

    do {
      container = this.map.get(elem);
      if (container != null) {
        containers.push(container);
      }
      elem = elem.parentElement as HTMLElement;
    } while (elem != null);

    return containers.reverse();
  }
}
